import { post } from "../../utils/Backend";
import { useH5Mock } from "../../global/GlobalMock";
import {
  mockGetLatestViewpoints,
  mockGetOldViewpoints,
  mockGetPinnedViewpoints,
  mockListViewpointCategories,
  mockToggleViewpointCollect,
  mockToggleViewpointLike,
} from "./ViewpointFeedMock";
import type {
  ViewpointFeedCategoryListResult,
  ViewpointFeedEngagementParam,
  ViewpointFeedEngagementState,
  ViewpointFeedListKind,
  ViewpointFeedSliceQuery,
  ViewpointFeedSliceResult,
  ViewpointPinnedListQuery,
  ViewpointPinnedListResult,
} from "./ViewpointFeedTypes";

const mockViewpointFeed = useH5Mock && false;

const oldUrls: Record<ViewpointFeedListKind, string> = {
  all: "/lark/app/viewpointFeed/getOldViewpoints",
  liked: "/lark/app/viewpointFeed/getOldLikedViewpoints",
  collected: "/lark/app/viewpointFeed/getOldCollectedViewpoints",
};

const latestUrls: Record<ViewpointFeedListKind, string> = {
  all: "/lark/app/viewpointFeed/getLatestViewpoints",
  liked: "/lark/app/viewpointFeed/getLatestLikedViewpoints",
  collected: "/lark/app/viewpointFeed/getLatestCollectedViewpoints",
};

export const ViewpointFeedApi = {
  async getOldViewpoints(
    query: ViewpointFeedSliceQuery,
    kind: ViewpointFeedListKind = "all"
  ): Promise<ViewpointFeedSliceResult | string> {
    if (mockViewpointFeed) {
      return mockGetOldViewpoints(query, kind);
    }
    return post<ViewpointFeedSliceQuery, ViewpointFeedSliceResult>(oldUrls[kind], query, {
      silent: true,
    });
  },

  async getLatestViewpoints(
    query: ViewpointFeedSliceQuery,
    kind: ViewpointFeedListKind = "all"
  ): Promise<ViewpointFeedSliceResult | string> {
    if (mockViewpointFeed) {
      return mockGetLatestViewpoints(query, kind);
    }
    return post<ViewpointFeedSliceQuery, ViewpointFeedSliceResult>(latestUrls[kind], query, {
      silent: true,
    });
  },

  async getPinnedViewpoints(
    query: ViewpointPinnedListQuery
  ): Promise<ViewpointPinnedListResult | string> {
    if (mockViewpointFeed) {
      return mockGetPinnedViewpoints(query);
    }
    return post<ViewpointPinnedListQuery, ViewpointPinnedListResult>(
      "/lark/app/viewpointFeed/getPinnedViewpoints",
      query,
      { silent: true }
    );
  },

  async toggleLike(
    param: ViewpointFeedEngagementParam
  ): Promise<ViewpointFeedEngagementState | string> {
    if (mockViewpointFeed) {
      return mockToggleViewpointLike(param);
    }
    return post<ViewpointFeedEngagementParam, ViewpointFeedEngagementState>(
      "/lark/app/viewpointFeed/toggleViewpointLike",
      param,
      { silent: true }
    );
  },

  async toggleCollect(
    param: ViewpointFeedEngagementParam
  ): Promise<ViewpointFeedEngagementState | string> {
    if (mockViewpointFeed) {
      return mockToggleViewpointCollect(param);
    }
    return post<ViewpointFeedEngagementParam, ViewpointFeedEngagementState>(
      "/lark/app/viewpointFeed/toggleViewpointCollect",
      param,
      { silent: true }
    );
  },

  async listViewpointCategories(query: {
    spaceId: string;
    spaceProductId: string;
  }): Promise<ViewpointFeedCategoryListResult | string> {
    if (mockViewpointFeed) {
      return mockListViewpointCategories(query);
    }
    return post<
      { spaceId: string; spaceProductId: string },
      ViewpointFeedCategoryListResult
    >("/lark/app/viewpointFeed/listViewpointCategories", query, { silent: true });
  },
};
